import React from 'react';
import PropTypes from 'prop-types';

const BAV = ({ fill, theme, ...props }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.8923 7.00833V6.66666C17.8889 6.51875 17.8463 6.37441 17.7686 6.24846C17.691 6.1225 17.5813 6.01949 17.4507 5.94999L10.3673 2.32499C10.2532 2.26907 10.1278 2.23999 10.0007 2.23999C9.87355 2.23999 9.74812 2.26907 9.63398 2.32499L2.55065 5.97499C2.42361 6.04238 2.31617 6.14149 2.23877 6.26269C2.16138 6.38389 2.11667 6.52306 2.10898 6.66666V6.98333C2.10898 7.20434 2.19678 7.4163 2.35306 7.57258C2.50934 7.72886 2.7213 7.81666 2.94232 7.81666H4.16732V16.15H2.91732C2.6963 16.15 2.48434 16.2378 2.32806 16.3941C2.17178 16.5504 2.08398 16.7623 2.08398 16.9833C2.08398 17.2043 2.17178 17.4163 2.32806 17.5726C2.48434 17.7289 2.6963 17.8167 2.91732 17.8167H17.084C17.305 17.8167 17.517 17.7289 17.6732 17.5726C17.8295 17.4163 17.9173 17.2043 17.9173 16.9833C17.9173 16.7623 17.8295 16.5504 17.6732 16.3941C17.517 16.2378 17.305 16.15 17.084 16.15H15.834V7.81666H17.084C17.2964 7.81038 17.4984 7.7232 17.6486 7.57295C17.7989 7.42269 17.886 7.22072 17.8923 7.00833ZM10.0007 3.99166L14.3257 6.19999H5.67565L10.0007 3.99166ZM5.83398 7.81666H9.16732V16.15H5.83398V7.81666ZM14.1673 16.15H10.834V7.81666H14.1673V16.15Z"
      fill="#6B6C7B"
    />
  </svg>
);

BAV.propTypes = {
  fill: PropTypes.string,
  theme: PropTypes.object,
};

export default BAV;
